module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-active@3x-b8c0cdc7.svg";